/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';

class Channel extends React.Component {
  render() {
    return <div>
      {this.props.children}
    </div>
  }
};
export default Channel;


// WEBPACK FOOTER //
// ./src/routes/channel/index.js